import React, { useEffect, useState } from "react";
import { apiClient } from "../../lib/api";
import { openSettings } from "../../lib/consent";

export default function Footer() {
  const [whatsapp, setWhatsapp] = useState("");

  useEffect(() => {
    apiClient
      .get("/config")
      .then((r) => setWhatsapp(r.data.whatsapp_url || ""))
      .catch(() => {});
  }, []);

  return (
    <footer
      id="footer"
      className="section-cream relative border-t border-[#0B0E13]/10 py-16 md:py-20 overflow-hidden"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 relative z-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <img
              src="https://customer-assets.emergentagent.com/job_sircs-test/artifacts/e5ti8jys_Photoroom_20260621_143416.png"
              alt="SIRCS — Santi Lorenzo"
              className="h-14 w-auto"
              style={{ filter: "brightness(0.15) saturate(1.2)" }}
            />
          </div>
          <p className="text-[#3A414C] text-base leading-relaxed max-w-sm font-light font-sans">
            Método SIRCS · Sistema Integral de Reprogramación Consciente y Subconsciente. Un
            método para identificar los patrones que han estado dirigiendo tu vida.
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="overline mb-6">Masterclass</p>
          <ul className="space-y-3 text-base font-sans">
            <li>
              <a
                href="#reservar"
                className="text-[#3A414C] hover:text-[#8E7A55] font-light transition-colors inline-flex items-center gap-2"
                data-testid="footer-reservar"
              >
                <span className="text-[#C7AA78]">→</span> Avísame de la próxima
              </a>
            </li>
            <li>
              <a
                href="#santi"
                className="text-[#3A414C] hover:text-[#8E7A55] font-light transition-colors inline-flex items-center gap-2"
                data-testid="footer-santi"
              >
                <span className="text-[#C7AA78]">→</span> Sobre Santi
              </a>
            </li>
            <li>
              <a
                href="https://santilorenzo.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#3A414C] hover:text-[#8E7A55] font-light transition-colors inline-flex items-center gap-2"
                data-testid="footer-web"
              >
                <span className="text-[#C7AA78]">→</span> Web principal
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="overline mb-6">Canal privado</p>
          {whatsapp && (
            <a
              href={whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline-gold inline-flex items-center gap-2"
              data-testid="footer-whatsapp"
            >
              Unirme al canal →
            </a>
          )}
          <p className="text-[#6E7580] text-sm mt-5 leading-relaxed font-light font-sans">
            Reflexiones semanales, materiales previos a la masterclass y avisos de próximas
            sesiones.
          </p>
        </div>
      </div>

      <div className="hairline my-12 max-w-7xl mx-auto relative z-10" style={{ background: "linear-gradient(90deg, transparent, rgba(11,14,19,0.20), transparent)" }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 relative z-10">
        <p className="text-sm text-[#6E7580] tracking-wide font-light font-sans">
          © {new Date().getFullYear()} Santi Lorenzo — Método SIRCS. Todos los derechos
          reservados.
        </p>
        <nav
          aria-label="Enlaces legales"
          className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm font-light font-sans"
          data-testid="footer-legal-nav"
        >
          <a
            href="/aviso-legal"
            className="text-[#6E7580] hover:text-[#0B0E13] transition-colors"
            data-testid="footer-aviso-legal"
          >
            Aviso legal
          </a>
          <a
            href="/politica-de-privacidad"
            className="text-[#6E7580] hover:text-[#0B0E13] transition-colors"
            data-testid="footer-politica-privacidad"
          >
            Política de privacidad
          </a>
          <a
            href="/politica-de-cookies"
            className="text-[#6E7580] hover:text-[#0B0E13] transition-colors"
            data-testid="footer-politica-cookies"
          >
            Política de cookies
          </a>
          <button
            type="button"
            onClick={openSettings}
            className="text-[#6E7580] hover:text-[#0B0E13] transition-colors bg-transparent border-0 p-0 font-inherit cursor-pointer"
            style={{ font: "inherit" }}
            data-testid="footer-configurar-cookies"
          >
            Configurar cookies
          </button>
          <a
            href="/admin"
            className="text-[#6E7580] hover:text-[#0B0E13] transition-colors"
            data-testid="footer-admin-link"
          >
            Admin
          </a>
        </nav>
      </div>
    </footer>
  );
}
